<mat-card class="sdp-user-wizard-container">
	<div class="sdp-wizard-section-body">
		<h3 class="sdp-edit-dialog-header sdp-applicationWizard-step-header">
			<sdp-icon [icon]="icon"></sdp-icon>
			{{ title }}
		</h3>
		<div
			class="sdp-saml-wizard-description"
			[innerHTML]="description"
		>
		</div>
		<div class="sdp-clear"></div>
		<div>
			<div #sdpWizardStep></div>
		</div>
	</div>
	<div class="sdp-wizard-section-footer">
		<div class="sdp-form-buttons-container">
			<button
				class="sdp-button-small-text"
				(click)="closeDialog()"
				type="button"
				color="primary"
				[disabled]="performingStep"
				mat-button
			>{{ "sdp.label.cancel" | translate }}</button>
			<button
				*ngIf="hasPrevious()"
				type="button"
				color="accent"
				(click)="goPrevious()"
				[disabled]="performingStep"
				mat-raised-button
			>{{ "form.label.back" | translate }}</button>
			<button
				type="button"
				color="primary"
				(click)="goNext()"
				[disabled]="!isFormValid || performingStep"
				mat-raised-button
			>{{ next() }}</button>
		</div>
	</div>
	<mat-progress-bar
		mode="indeterminate"
		*ngIf="showProgressBar"
		class="sdp-progress-bar"
	></mat-progress-bar>
</mat-card>